{% block sw_category_view_tabs_seo %}

    {% parent %}

    <sw-tabs-item
            v-show="cmsPage || isPage"
            class="sw-category-detail__tab-topfeed"
            :route="{ name: 'sw.category.detail.topfeed' }"
            :title="$t('TopdataTopfeedSW6.tabCategoryTopfeedSettings')"
    >
        {{ $t('TopdataTopfeedSW6.tabCategoryTopfeedSettings') }}
    </sw-tabs-item>


{% endblock %}
